import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useParams } from 'react-router-dom';
import { List } from 'immutable';
import {
    getCalendar,
    updateOpeningHours,
} from 'flow/actions/extension-actions';
import {
    clearCalendarEvents,
    fetchProfiles,
    updateCalendar,
} from 'flow/actions/profile-actions';
import CalendarBase from 'flow/components/calendar/CalendarBase';
import useBackToOrigin from 'flow/hooks/useBackToOrigin';
import Loading from 'flow/components/ui-components/Loading';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

import { getCalendarWithActiveProfileAddedToEvents } from 'flow/utils/calendar-utils';
import { sortProfilesAfterPlusId } from 'flow/utils/profile-utils';

const ExtensionCalendar = () => {
    const dispatch = useAppDispatch();
    const { entityKey } = useParams<{ entityKey: ExtensionKey }>();
    const handleBack = useBackToOrigin(() =>
        generatePath(routes['extensions.entityKey.contact'], { entityKey }),
    );

    const profiles = useAppSelector((state) =>
        state.profiles.get(entityKey, List()),
    );

    const calendar = useAppSelector((state) =>
        state.extensions.getIn(['extensions', entityKey, 'calendar']),
    );

    useEffect(() => {
        dispatch(getCalendar(entityKey));
        dispatch(fetchProfiles(entityKey));
    }, []);

    if (!calendar || !profiles) {
        return <Loading signalFinishedLoading={true} />;
    }

    return (
        <CalendarBase
            calendar={getCalendarWithActiveProfileAddedToEvents(null, calendar)}
            entityKey={entityKey}
            profiles={sortProfilesAfterPlusId(profiles)}
            showExternallyManagedInfo={true}
            onClickBack={handleBack}
            updateOpeningHours={(openingHours) =>
                dispatch(updateOpeningHours(entityKey, openingHours))
            }
            clearCalendar={() => dispatch(clearCalendarEvents(entityKey))}
            updateCalendar={(updatedCalendar) => {
                dispatch(updateCalendar(entityKey, updatedCalendar));
            }}
        />
    );
};

export default ExtensionCalendar;
